import { combineReducers } from "@reduxjs/toolkit";
import prifileReducer from "./profile-store";
import webcontentReducer from "./webcontent-store";
import consultReducer from "./consult-store";

const rootReducer = combineReducers({
  profile: prifileReducer.reducer,
  webcontent: webcontentReducer.reducer,
  consult: consultReducer.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
